import { CLOSE_THUMBNAILS_NAVIGATION, OPEN_THUMBNAILS_NAVIGATION } from 'redux/thumbnails/actions'
import { set } from 'immutadot'

const initialState = { isOpened: false }

export const thumbnails = (state = initialState, { type }) => {
    switch (type)
    {
        case OPEN_THUMBNAILS_NAVIGATION:
            return set(state, 'isOpened', true)

        case CLOSE_THUMBNAILS_NAVIGATION:
            return set(state, 'isOpened', false)

        default:
            return state
    }
}

